export enum ApiStates {
  RESET = 'RESET',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  ERROR = 'ERROR',
  FILTER = 'FILTER',
}
